module.exports = Promise.all([__parcel__import__("duLj1"), __parcel__import__("ekj1G")]).then(() => parcelRequire('4qady'));